module.exports = new __parcel__URL__("written.dbcfdc37.webp").toString();